const styleAttrRegex = /\s?style="[^"]*"/g;

export const removeStyleAttribute = html => html && html.replace(styleAttrRegex, '');
